import { Suspense, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import Nav from "./Nav";
import Footer from "./Footer";
import { scrollToId } from "../../lib/img";

const useScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, behavior: "instant" });
      return;
    }
    let n = 0;
    const t = setInterval(() => {
      const el = document.getElementById(hash.slice(1));
      if (el || n++ > 30) {
        clearInterval(t);
        if (el) scrollToId(hash.slice(1));
      }
    }, 100);
    return () => clearInterval(t);
  }, [pathname, hash]);
};

export default function Layout() {
  const { pathname } = useLocation();
  useScrollManager();
  return (
    <>
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:rounded-full focus:bg-ink focus:px-5 focus:py-3 focus:text-ivory">
        Skip to content
      </a>
      <Nav />
      <main id="main" className="overflow-x-clip" data-testid="page-main">
        <Suspense fallback={<div className="min-h-screen bg-ivory" />}>
          <motion.div key={pathname} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5, ease: "easeOut" }}>
            <Outlet />
          </motion.div>
        </Suspense>
      </main>
      <Footer />
    </>
  );
}
